import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { getDomainRoutingInfo } from '../util/domainRouting';

const SubdomainPathGuard = ({ history, location }) => {
    useEffect(() => {
        const { isOrgSubdomain } = getDomainRoutingInfo();
        const currentPath = location.pathname || '/';

        // Allow only specific public-profile routes on org subdomains
        const allowedPaths = ['/'];

        const allowedPatterns = [
            /^\/blog\/[^/]+$/, // article detail page
        ];

        const isAllowedPath =
            allowedPaths.includes(currentPath) ||
            allowedPatterns.some(pattern => pattern.test(currentPath));

        if (isOrgSubdomain && !isAllowedPath) {
            history.replace('/');
        }
    }, [history, location.pathname]);

    return null;
};

export default withRouter(SubdomainPathGuard);
